<template>
  <available-section section="schedule">
    <section class="schedule-appointment">
      <slot name="side-bar" />
      <div class="schedule-appointment__wrap">
        <div class="only-print">
          <slot name="only-print" />
        </div>
        <slot />
      </div>
      <side-slide-transition>
        <slot name="side-dialogs" />
      </side-slide-transition>
    </section>
    <template v-slot:denied>
      <p class="schedule-appointment__notification">У вас нет прав на просмотр расписания</p>
    </template>
  </available-section>
</template>

<script>
import AvailableSection from '@/views/ClinicPanel/AvailableSection.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';

export default {
  components: { AvailableSection, SideSlideTransition },
  name: 'ClinicPanelAppointmentSchedule',
};
</script>

<style lang="scss">
@use "@/scss/buttons";

$button-font-size: 14px;
$button-height: 33px;
$button-width: 100%;
.only-print {
  display: none;
}
.modal-dialog {
  &__buttons {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    gap: 10px;
  }
  &__cancel {
    @include buttons.btn-transparent(250px, 40px, 16px);
    max-width: 100%;
  }
  &__agree {
    @include buttons.btn-blue(250px, 40px, 16px);
    max-width: 100%;
  }
}
.timetable-cell {
  background-color: #ffffff;
}

.schedule-appointment {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  overflow: auto;
  &__wrap {
    padding-bottom: 6px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
  }
  &__body {
    display: flex;
    flex-direction: row;
    width: fit-content;
    position: relative;
    top: initial !important;
  }
  &__print {
    display: none;
  }
  &__timetable {
    overflow-x: scroll;
    &__grid {
      display: flex;
      flex-direction: row;
      padding: 0;
      width: 100%;
      height: fit-content;
      &:not(.await):empty::before {
        content: attr(msg);
        font-size: 20px;
        line-height: 25px;
        font-weight: 600;
        margin: 45px;
      }
      &.h-auto {
        height: auto;
        width: auto;
      }
    }
    &__column {
      display: flex;
      flex-direction: column;
      width: 170px;
      max-width: 170px;
      min-width: 170px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      &:last-of-type {
        border-right: 1px solid rgba(0, 0, 0, 0.12);
      }
    }
  }
  &__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    max-width: 438px;
    width: 100%;
    margin: 10px 0 0 auto;
  }
  &__button {
    &-cancel {
      max-width: 219px;
      @include buttons.btn-transparent(100%, 56px, 20px);
    }
    &-save {
      max-width: 219px;
      @include buttons.btn-blue(100%, 56px, 20px);
      &:disabled {
        background-color: var(--unfocus-color);
        border-color: var(--unfocus-color);
      }
    }
  }
  &__collapse {
    display: none;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 15px;
    &:before {
      content: "";
      background-image: url("@/assets/img/collapse-active-reverse.svg");
      background-repeat: no-repeat;
      background-position: center;
      width: 24px;
      height: 24px;
    }
  }
  &__notification {
    padding: 50px 0 0 10px;
    font-size: 14px;
    line-height: 14px;
    a:hover {
      text-decoration: none;
    }
  }
}
.aggregator-order-dialog,
.nearest-unconfirmed-appointment-dialog,
.work-time-controls-side-dialog {
  & &__body {
    margin-top: 2.2rem;
  }
  & &__link {
    margin-top: 20px;
    display: inline-block;
    &:hover {
      text-decoration: none;
    }
  }
}
@media print {
  .only-print {
    display: block;
  }
  .schedule-appointment__side-bar {
    display: none !important;
  }
  .schedule-appointment__wrap {
    padding: 20px;
  }
  .head-panel {
    display: none;
  }
  .clinic-panel {
    width: fit-content;
    height: fit-content;
    min-height: fit-content;
  }
  .schedule-appointment__timetable__cell,
  .schedule-appointment__timetable__employee__print {
    break-inside: avoid;
  }
  .schedule-appointment__side-bar__row {
    display: none;
  }
}
@media screen and (max-width: 480px) {
  .schedule-appointment {
    flex-direction: column;
    overflow: hidden;
    &__wrap {
      display: flex;
      flex-direction: column;
      padding: 0;
    }
    &__body {
      width: 100%;
      overflow-x: scroll;
    }
    &__collapse {
      display: flex;
    }
    &__timetable__column {
      max-width: 100%;
      width: calc(100% - 140px);
      min-width: 220px;
      border-bottom: none;
      &:last-child {
        padding-right: 20px;
        border-right: none;
      }
    }
    &__wrap {
      flex: 1;
    }
  }
}
</style>
